<template>
<v-container fluid class="page-wrap">
    <v-row>
      <v-col cols="12" class="text-center">
          <header-vue/>
      </v-col>

      <v-col
        class="mb-5"
        md="12"
      >
            <v-card class="rounded-xl pa-2 pa-md-3" elevation="3">
                <v-card-title class="page-title-row">
                    <div>
                        <div class="text-overline accent--text font-weight-bold">ATTENDANCE</div>
                        <div class="text-h6 font-weight-bold primary--text">Manage Teaching Staff</div>
                        <div class="text-body-2 grey--text">Add staff and optionally link them to a login account for self-service clock-in/out</div>
                    </div>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12">
                            <create-teacher-form :authToken="authToken" :school="school" :editFormSignal="editFormSignal" :refreshRecordSignal="refreshRecordSignal" @refresh="getTeachers"/>
                        </v-col>
                        <v-col cols="12">
                            <info-loader-2 v-if="fetchingContent"/>
                            <v-card outlined class="rounded-lg" v-else>
                                <v-data-table
                                    :headers="headers"
                                    :items="records"
                                    class="elevation-0"
                                    dense
                                    disable-pagination
                                    hide-default-footer
                                >
                                    <template v-slot:item.name="{ item }">
                                        <span v-if="item.status === 'inactive'" style="color: dimgray;">
                                            <em><del>{{ item.firstname }} {{ item.middlename }} {{ item.lastname }}</del></em>
                                        </span>
                                        <span v-else>
                                            {{ item.firstname }} {{ item.middlename }} {{ item.lastname }}
                                        </span>
                                    </template>

                                    <template v-slot:item.gender="{ item }">
                                        {{ genderLabel(item.gender) }}
                                    </template>

                                    <template v-slot:item.linked_account="{ item }">
                                        <span v-if="item.user">{{ item.user.fullname }} ({{ item.user.email }})</span>
                                        <span v-else class="grey--text">Not linked</span>
                                    </template>

                                    <template v-slot:item.status="{ item }">
                                        <v-chip :color="item.status === 'active' ? 'green' : 'grey'" dense dark>
                                            {{ item.status }}
                                        </v-chip>
                                    </template>

                                    <template v-slot:item.actions="{ item }">
                                        <v-btn @click="editFormSignal = item" fab light x-small class="mr-2" elevation="1">
                                            <v-icon small>mdi-pencil</v-icon>
                                        </v-btn>
                                    </template>
                                </v-data-table>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';
import HeaderVue from '../../components/Header.vue'
import InfoLoader2 from '../../components/InfoLoader2.vue';
import CreateTeacherForm from '../../components/parts/CreateTeacherForm.vue';

export default {
    name: 'ManageStaff',
    components: {
        HeaderVue,
        InfoLoader2,
        CreateTeacherForm,
    },
    data: () => ({
        authToken: sessionStorage.getItem('authToken') ?? null,
        school: localStorage.getItem('school') ? JSON.parse(localStorage.getItem('school')) : null,
        editFormSignal: false,
        refreshRecordSignal: false,
        fetchingContent: true,
        records: [],
        headers: [
            { value: 'name', text: 'Name' },
            { value: 'gender', text: 'Gender' },
            { value: 'linked_account', text: 'Linked Account' },
            { value: 'status', text: 'Status' },
            { value: 'actions', text: 'Actions', sortable: false },
        ],
    }),
    mounted() {
        if (!this.authToken) {
            this.$router.push({name: 'Login'})
        }
        this.getTeachers()
    },
    methods: {
        getTeachers () {
            axios.get(process.env.VUE_APP_BASEURL+'/teachers?school_id='+this.school.school_id,
            {
                headers:
                {
                    'Authorization': 'Bearer '+this.authToken
                }
            })
            .then((response) => {
                this.records = response.data.data
                this.refreshRecordSignal = Math.random()
            })
            .catch((error) => {
                if (error.response.status == 401) {
                    localStorage.removeItem('authToken')
                }
                this.$toast.error(error.response ? error.response.data.message : 'APP is temporarily unavailable. Wait or Contact us!', {
                    timeout: 5000
                });
            })
            .finally(() => {
                this.fetchingContent = false
            });
        },
        genderLabel (gender) {
            return { '0': 'Male', '1': 'Female' }[gender] ?? '-'
        },
    },
}
</script>

<style scoped>
</style>
